import { createContactOrdersBatch } from "../../../../../api/kehrblatt/contact-orders"
import type {
  ContactOrderPlanningCreateCommandInput,
  ContactOrderPlanningCreateCommandResult,
} from "../../../_shared/_logic/contact-orders-contract"
import { projectContactOrderCreateResult } from "../../../_shared/_logic/create-result"

export const executeCreateContactOrders = async ({
  payloads,
  targetEvents,
  events,
  contactOrders,
}: ContactOrderPlanningCreateCommandInput): Promise<ContactOrderPlanningCreateCommandResult> => {
  const result = await createContactOrdersBatch(payloads)
  const projection = projectContactOrderCreateResult({
    result,
    targetEvents,
    events,
    contactOrders,
  })

  return {
    result,
    ...projection,
    completedCount: projection.created.length,
  }
}
